import { RouteRecordRaw } from "vue-router";

const cities: RouteRecordRaw = {
  path: "cities",
  component: () => import("@/views/public/index.vue"),
  meta: {
    title: "المدن",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "index-cities",
      component: () => import("@/views/public/cities/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "المدن",
      },
    },
    {
      path: "add",
      name: "add-city",
      component: () => import("@/views/public/cities/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "add",
        title: "AddNew",
      },
    },
    {
      path: "Edit/:Id",
      props: true,
      name: "edit-city",
      component: () => import("@/views/public/cities/pages/add.vue"),
      meta: {
        pageId: 18010400,
        role: "edit",
        title: "Edit",
      },
    },
  ],
};

export default cities;
